var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['block.cmpMediaGallery'] = (function () {
    'use strict';

    const initialize = (widget) => {

        const carouselEl = widget.querySelector(".splide");
        if (!carouselEl) return;

        const splideOptions = {
            type: "loop",
            focus: "center",
            pagination: false,
            arrows: false,
            autoWidth: true
        };

        App.Helpers.splideFallback(
            carouselEl,
            splideOptions,
            (splide) => {
                splideEventBindings(splide, carouselEl, widget);
            }
        );
    };

    const splideEventBindings = (splide, carouselEl, widget) => {

        const arrows = widget.querySelector(".cmp--mediaGallery__arrows");
        const status = widget.querySelector(".cmp--mediaGallery__status");
        let buttons = widget.querySelectorAll(".splide__slide button");
        const media = widget;

        splide.on("mounted", () => {
            // active button
            const firstSlide = splide.Components.Slides.getAt(0).slide;
            const buttonActive = firstSlide.querySelector("button");

            if (buttonActive) {
                buttonActive.setAttribute("aria-selected", "true");
            }

            // arrows
            const nextArrow = arrows.querySelector(".splide__arrow--next");
            const prevArrow = arrows.querySelector(".splide__arrow--prev");

            nextArrow?.addEventListener("click", () => splide.go('>'));
            prevArrow?.addEventListener("click", () => splide.go('<'));

            // refresh buttons
            buttons = carouselEl.querySelectorAll(".splide__slide button");

            // button click, go to slide
            buttons.forEach(btn => {
                btn.addEventListener("click", function () {
                    const index = this.dataset.index;
                    if (index !== undefined) {
                        splide.go(Number(index));
                    }
                });
            });

            // status
            status.querySelector(".current").textContent = "1";
            status.querySelector(".divider").textContent = "/";
            status.querySelector(".total").textContent = splide.length;
        });

        splide.on("move", (nextSlide, prevSlide) => {
            // active button
            const slideEl = splide.Components.Slides.getAt(nextSlide).slide;
            const buttonActive = slideEl.querySelector("button");

            // toggle aria-selected
            buttons.forEach(btn => {
                btn.setAttribute("aria-selected", btn === buttonActive ? "true" : "false");
            });

            // update status
            status.querySelector(".current").textContent = nextSlide + 1;

            // stop all videos
            const iframes = media.querySelectorAll(".cmp--multiMedia__video iframe");
            iframes.forEach(iframe => {
                const multiMedia = iframe.closest(".cmp--multiMedia__video");
                if (multiMedia) {
                    App.CmpMultiMedia.stop(multiMedia);
                }
            });

            // show/hide content
            const targetId = buttonActive?.getAttribute("aria-controls");
            if (targetId) {
                const target = media.querySelector(`.cmp--mediaGallery__media__item#${targetId}`);
                const activeItems = media.querySelectorAll(".cmp--mediaGallery__media__item.active");

                activeItems.forEach(el => el.classList.remove("active"));
                target?.classList.add("active");
            }
        });
    };

    return {
        initialize
    };

})();